import React, { ReactNode } from 'react';

import { PageBlockContext, PageBlockContextShape } from './PageBlockContext';

type PageBlockProviderProps = {
  children: ReactNode;
  size: PageBlockContextShape['size'];
};

export const PageBlockProvider = ({
  children,
  size,
}: PageBlockProviderProps) => {
  return (
    <PageBlockContext.Provider value={{ size }}>
      {children}
    </PageBlockContext.Provider>
  );
};
